/*	-----------------------------------------------------------------------------------------------
	Namespace
--------------------------------------------------------------------------------------------------- */

var cdbootstrap = cdbootstrap || {},
    $ = jQuery;
window.cdbootstrap = cdbootstrap;


/*	-----------------------------------------------------------------------------------------------
	Global variables
--------------------------------------------------------------------------------------------------- */

var $cdbootstrapDoc = $( document ),
    $cdbootstrapWin = $( window );


/*	-----------------------------------------------------------------------------------------------
	Helper functions
--------------------------------------------------------------------------------------------------- */

/* Output AJAX errors ------------------------ */

function cdbootstrapAjaxErrors( jqXHR, exception ) {
	var message = '';
	if ( jqXHR.status === 0 ) {
		message = 'Not connect.n Verify Network.';
	} else if ( jqXHR.status == 404 ) {
		message = 'Requested page not found. [404]';
	} else if ( jqXHR.status == 500 ) {
		message = 'Internal Server Error [500].';
	} else if ( exception === 'parsererror' ) {
		message = 'Requested JSON parse failed.';
	} else if ( exception === 'timeout' ) {
		message = 'Time out error.';
	} else if ( exception === 'abort' ) {
		message = 'Ajax request aborted.';
	} else {
		message = 'Uncaught Error.n' + jqXHR.responseText;
	}
	console.log( 'AJAX ERROR:' + message );
}

/*	-----------------------------------------------------------------------------------------------
	Interval Scroll
--------------------------------------------------------------------------------------------------- */

cdbootstrap.intervalScroll = {

	init: function() {

		var didScroll = false;

		// Check for the scroll event.
		$cdbootstrapWin.on( 'scroll load', function() {
			didScroll = true;
		} );

		// Once every 250ms, check if we have scrolled, and if we have, do the intensive stuff.
		setInterval( function() {
			if ( didScroll ) {
				didScroll = false;

				// When this triggers, we know that we have scrolled.
				$cdbootstrapWin.trigger( 'did-interval-scroll' );

			}

		}, 250 );

	},

} // cdbootstrap.intervalScroll

/*	-----------------------------------------------------------------------------------------------
	Toggles
--------------------------------------------------------------------------------------------------- */

cdbootstrap.toggles = {

	init: function() {

		const openButton = document.getElementById('filter-pane-open');
		const filterPane = document.getElementById('filter-pane');
		const closeButton = document.getElementById('filter-pane-close');
		if( openButton && filterPane && closeButton ){
			openButton.addEventListener('click', () => {
				filterPane.classList.add('open');
				filterPane.style.display = 'flex';
				window.addEventListener( 'click', function(e){
					if( ! filterPane.contains(e.target) && ! openButton.contains(e.target) && filterPane.classList.contains('open') ){
						filterPane.classList.remove('open');
						filterPane.style.display = 'none';
					}
				})
			})
			closeButton.addEventListener('click', () => {
				filterPane.classList.remove('open');
				filterPane.style.display = 'none';
			})
		}
	},

} // cdbootstrap.toggles

/*	-----------------------------------------------------------------------------------------------
	Count Applied Toggles -- adds a number beside the label
--------------------------------------------------------------------------------------------------- */

function cdboostrapCountAppliedFilters() {
	var accordions = $('#filter-accordions-wrapper .accordion-item'); //.find('.accordion-item-count-container');
	var totalCount = 0;
	accordions.each(function(){
		var activeFilters = $(this).find('li.active');
		var counterContainer = $(this).find('.accordion-item-count-container');
		counterContainer.data('active-filter-count', activeFilters.length);
		totalCount = totalCount + activeFilters.length;
		if( activeFilters.length >= 1 ){
			counterContainer.text(activeFilters.length);
		} else {
			counterContainer.text('');
		}
	});
	if( totalCount > 0 ){
		$('#filter-pane-open').empty().append('Filters<span class="filters-total-count">' + totalCount + '</span>' );
	} else {
		$('#filter-pane-open').text('Filters');
	}
}

/*	-----------------------------------------------------------------------------------------------
	Update URL search params
--------------------------------------------------------------------------------------------------- */

var setSearchParam = function(key, value) {
	if (!window.history.pushState) {
		return;
	}

	if (!key) {
		return;
	}

	var url = new URL(window.location.href);
	var params = new window.URLSearchParams(window.location.search);
	if (value === undefined || value === null) {
		params.delete(key);
	} else {
		params.set(key, value);
	}
	url.search = params;
	url = url.toString();
	window.history.replaceState({url: url}, null, url);
}

function intersection (a, b) {
	const setA = new Set(a);
	return b.filter(value => setA.has(value));
}

var updateSearchParams = function(queryArgsParsed) {
	// post type, taxonomy, author, search
	const resourceHubPostTypes = [
		"white-papers",
		"post",
		"podcasts",
		"webinars",
		"videos",
		"events",
		"analyst-report",
	]
	const newsRoomPostTypes = [
		"press",
		"news",
	]
	if( Array.isArray( queryArgsParsed.post_type ) ){
		let queryPostType = intersection( resourceHubPostTypes, queryArgsParsed.post_type);
		if( queryPostType.length === 7 ||  queryPostType.length === 0){
			setSearchParam( 'resource-type', null );
		} else {
			setSearchParam( 'resource-type', queryPostType );
		}
		queryPostType = intersection( newsRoomPostTypes, queryArgsParsed.post_type);
		if( queryPostType.length === 2 || queryPostType.length === 0 ){
			setSearchParam( 'news-type', null );
		} else {
			setSearchParam( 'news-type', queryPostType );
		}
	}
	if( queryArgsParsed.tax_query ){
		queryArgsParsed.tax_query.forEach( tax => {
			if( tax.taxonomy === 'topics' ){
				setSearchParam( 'topics', tax.terms );
			} else if( tax.taxonomy === 'customers-category') {
				setSearchParam( 'customers-cat', tax.terms );
			} else if( tax.taxonomy === 'partners-category') {
				setSearchParam( 'partners-cat', tax.terms );
			} else {
				setSearchParam( tax.taxonomy, tax.terms );
			}
		})
	}
	if( ! queryArgsParsed.hasOwnProperty('tax_query') && queryArgsParsed.hasOwnProperty('taxonomy') ){
		setSearchParam( queryArgsParsed.taxonomy, null );
	}
	if( queryArgsParsed.author__in.length ){
		setSearchParam( 'auth', queryArgsParsed.author__in );
	}else{
		setSearchParam( 'auth', null );
	}

}

/*	-----------------------------------------------------------------------------------------------
	Load More
--------------------------------------------------------------------------------------------------- */

cdbootstrap.loadMore = {

	init: function() {

		var $pagination = $( '#pagination' );
		var $modalPagination = $( '#modal-pagination' );

		// First, check that there's a pagination.
		if ( $pagination.length ) {

			// Default values for variables.
			window.cdbootstrapIsLoading = false;
			window.cdbootstrapIsLastPage = $( '.pagination-wrapper' ).hasClass( 'last-page' );

			cdbootstrap.loadMore.prepare( $pagination );

		}

		// First, check that there's a pagination.
		if ( $modalPagination.length ) {

			// Default values for variables.
			window.cdbootstrapIsLoading = false;
			window.cdbootstrapModalIsLastPage = $modalPagination.closest( '.pagination-wrapper' ).hasClass( 'last-page' );

			cdbootstrap.loadMore.prepare( $modalPagination );

		}

		// When the pagination query args are updated, reset the posts to reflect the new pagination
		$cdbootstrapWin.on( 'reset-posts', function() {

			//refresh the variables
			$pagination = $( '#pagination' );
			$modalPagination = $( '#modal-pagination' );

			// Fade out the pagination and existing posts.
			$pagination.add( $( $pagination.data( 'load-more-target' ) ).find( '.card-outer-wrapper' ) ); //.animate( { opacity: 0 }, 300, 'linear' );
			$modalPagination.add( $( $modalPagination.data( 'load-more-target' ) ).find( '.card-outer-wrapper' ) ); //.animate( { opacity: 0 }, 300, 'linear' );

			// Reset posts.
			var resetPosts = true;
			cdbootstrap.loadMore.prepare( $pagination, resetPosts = true );
			cdbootstrap.loadMore.prepare( $modalPagination, resetPosts = true );
		} );

	},

	prepare: function( $pagination, resetPosts ) {

		// Default resetPosts to false.
		if ( typeof resetPosts === 'undefined' || ! resetPosts ) {
			resetPosts = false;
		}

		// Get the query arguments from the pagination element.
		var queryArgs;
		if( $pagination.attr( 'data-query-args' ) ){
			queryArgs = JSON.parse( $pagination.attr( 'data-query-args' ) );
		}

		// If we're resetting posts, reset them.
		if ( resetPosts ) {
			cdbootstrap.loadMore.loadPosts( $pagination, resetPosts );
		}

		// If not, check the paged value against the max_num_pages.
		else {
			if ( queryArgs.paged == queryArgs.max_num_pages ) {
				$pagination.closest( '.pagination-wrapper' ).addClass( 'last-page' );
			}

			// Get the load more type (button or scroll).
			var loadMoreType = $pagination.data( 'pagination-type' ) ? $pagination.data( 'pagination-type' ) : 'button';

			// Do the appropriate load more detection, depending on the type.
			if ( loadMoreType == 'scroll' ) {
				cdbootstrap.loadMore.detectScroll( $pagination );
			} else if ( loadMoreType == 'button' ) {
				cdbootstrap.loadMore.detectButtonClick( $pagination );
			}
		}

	},

	// Load more on scroll
	detectScroll: function( $pagination, query_args ) {

		$cdbootstrapWin.on( 'did-interval-scroll', function() {

			// If it's the last page, or we're already loading, we're done here.
			if ( cdbootstrapIsLastPage || cdbootstrapIsLoading ) {
				return;
			}

			var paginationOffset 	= $pagination.offset().top,
				winOffset 			= $cdbootstrapWin.scrollTop() + $cdbootstrapWin.outerHeight();

			// If the bottom of the window is below the top of the pagination, start loading.
			if ( ( winOffset > paginationOffset ) ) {
				cdbootstrap.loadMore.loadPosts( $pagination, query_args );
			}

		} );

	},

	// Load more on click.
	detectButtonClick: function( $pagination, query_args ) {

		// Load on click.
		$( '#load-more' ).on( 'click', function() {

			// Make sure we aren't already loading.
			if ( cdbootstrapIsLoading ) return;
			cdbootstrap.loadMore.incrementPage( $pagination );
			cdbootstrap.loadMore.loadPosts( $pagination, query_args );
			return false;
		} );

	},

	incrementPage: function( $pagination ) {
		var queryArgs 			= $pagination.attr( 'data-query-args' ),
		queryArgsParsed 		= JSON.parse( queryArgs );
		if( queryArgsParsed.hasOwnProperty('paged') ){
			queryArgsParsed.paged = queryArgsParsed.paged + 1;
			$pagination.attr( 'data-query-args', JSON.stringify( queryArgsParsed ) );
		}
	},

	// Load the posts
	loadPosts: function( $pagination, resetPosts ) {

		// Default resetPosts to false.
		if ( typeof resetPosts === 'undefined' || ! resetPosts ) {
			resetPosts = false;
		}

		// Get the query arguments.
		var queryArgs 			= $pagination.attr( 'data-query-args' ),
			queryArgsParsed,
			$paginationWrapper 	= $pagination.closest( '.pagination-wrapper' ),
			$articleWrapper 	= $( $pagination.data( 'load-more-target' ) );
			inModal			= $pagination.data( 'in-modal' );

		if(queryArgs){
			queryArgsParsed 	= JSON.parse( queryArgs );
			if( ! inModal ){
				updateSearchParams(queryArgsParsed);
			}
		}

		// We're now loading.
		cdbootstrapIsLoading = true;
		if ( ! resetPosts ) {
			$paginationWrapper.addClass( 'loading' );
		}

		// Prepare the query args for submission.
		var jsonQueryArgs = JSON.stringify( queryArgsParsed );

		$.ajax({
			url: majesco_2022_ajax_load_more.ajaxurl,
			type: 'post',
			data: {
				action: 'majesco_2022_ajax_load_more',
				json_data: jsonQueryArgs,
				in_modal: inModal
			},
			success: function( result ) {

				// Get the results.
				var $result = $( result );
				var $articles = $result.filter('div[class^="col"], .card-outer-wrapper');
				var $paginationLinks = $result.find( '#pagination .link-pagination' );

				// Account for cases where the article is not wrapped in a column
				console.log('Result: ', $result);
				console.log('Articles: ', $articles);
				console.log( $articles.length );
				if( ! $articles.length ){
					$articles = $result.find('article');
				}
				console.log( $articles );

				// If we're resetting posts, remove the existing posts.
				if ( resetPosts ) {
					$articleWrapper.find( '*:not(.grid-sizer)' ).remove();
				}
				// If there are no article results, we're at the last page.
				if ( ! $articles.length ) {
					cdbootstrapIsLoading = false;
					$articleWrapper.addClass( 'no-results' );
					$paginationWrapper.addClass( 'last-page' ).removeClass( 'loading' );
				}

				if ( $articles.length ) {

					console.log('article to append', $articles );

					$articleWrapper.removeClass( 'no-results' );

					// Add the paged attribute to the articles, used by updateHistoryOnScroll().
					$articles.each( function() {
						$( this ).attr( 'data-post-paged', queryArgsParsed.paged );
						$( this ).css( 'opacity', 0 ); //hide
					} );

					// Wait for the images to load.
					$result.imagesLoaded( function() {

						// Append the results.
						$articleWrapper.append( $articles ); //.masonry( 'appended', $result ).masonry();
						// Fade out the pagination and existing posts.
						$articleWrapper.find( '.col, .col-12, .card, .card-outer-wrapper, article.type-news, article.type-press, article.content-list' ).animate( { opacity: 1 }, 300, 'linear' );

						$cdbootstrapWin.trigger( 'ajax-content-loaded' );
						$cdbootstrapWin.trigger( 'did-interval-scroll' );

						// Replace the pagination links
						$paginationWrapper.find('nav.link-pagination').remove();
						$paginationWrapper.find('#pagination').append($paginationLinks);

						// We're now finished with the loading.
						cdbootstrapIsLoading = false;
						$paginationWrapper.removeClass( 'loading' );

						// Update the pagination query args.
						$pagination.attr( 'data-query-args', jsonQueryArgs );

						// Reset the resetting of posts.
						if ( resetPosts ) {
							setTimeout( function() {
								$('#pagination').animate( { opacity: 1 }, 600, 'linear' );
							}, 400 );
							$( 'body' ).removeClass( 'filtering-posts' );
						}
						// If that was the last page, make sure we don't check for more.
						if ( queryArgsParsed.paged == queryArgsParsed.max_num_pages ) {
							$paginationWrapper.addClass( 'last-page' );
							cdbootstrapIsLastPage = true;
							return;

						// If not, make sure the pagination is visible again.
						} else {
							$paginationWrapper.removeClass( 'last-page' );
							cdbootstrapIsLastPage = false;
						}

					} );

				}

			},

			error: function( jqXHR, exception ) {
				cdbootstrapAjaxErrors( jqXHR, exception );
			}
		} );

	},

} // cdbootstrap.loadMore

/*	-----------------------------------------------------------------------------------------------
	Filters
--------------------------------------------------------------------------------------------------- */

cdbootstrap.filters = {

	init: function() {
		cdboostrapCountAppliedFilters();
		//Taxonomy filter links
		$cdbootstrapDoc.on( 'click', '.filter-link', function() {

			$( 'body' ).addClass( 'filtering-posts' );

			var $link 		= $( this ),
				termId 		= $link.data( 'filter-term-id' ) ? $link.data( 'filter-term-id' ) : null,
				taxonomy 	= $link.data( 'filter-taxonomy' ) ? $link.data( 'filter-taxonomy' ) : null,
				postType 	= $link.data( 'filter-post-type' ) ? $link.data( 'filter-post-type' ) : '',
				addTerm		= $( this ).hasClass( 'active' ) ? false : true; //Should we add or remove the term from the query.

			$link.addClass( 'pre-active' );

			$.ajax({
				url: majesco_2022_ajax_filters.ajaxurl,
				type: 'post',
				data: {
					action: 	'majesco_2022_ajax_filters',
					post_type: 	postType,
					term_id: 	termId,
					taxonomy: 	taxonomy,
					addTerm:	addTerm,
					query:		$( '#pagination' ).attr( 'data-query-args' ),
				},
				success: function( result ) {

					// Add them to the pagination.
					$( '#pagination' ).attr( 'data-query-args', result );

					// Reset the posts.
					$cdbootstrapWin.trigger( 'reset-posts' );

					// Update active class.
					$( '.filter-link' ).removeClass( 'pre-active' );
					$link.toggleClass( 'active' );
					cdboostrapCountAppliedFilters();

				},

				error: function( jqXHR, exception ) {
					cdbootstrapAjaxErrors( jqXHR, exception );
				}
			} );

			return false;

		} );
		//Post Type filter links
		$cdbootstrapDoc.on( 'click', '.post-type-filter-link', function() {

			$( 'body' ).addClass( 'filtering-posts' );

			var $link 		= $( this ),
				postType 	= $link.data( 'filter-post-type' ) ? $link.data( 'filter-post-type' ) : '',
				addPostType	= $( this ).hasClass( 'active' ) ? false : true; //Should we add or remove the post type from the query.

			$link.addClass( 'pre-active' );

			$.ajax({
				url: majesco_2022_ajax_filters.ajaxurl,
				type: 'post',
				data: {
					action: 	'majesco_2022_ajax_filters_post_type',
					post_type: 	postType,
					addPostType:	addPostType,
					query:		$( '#pagination' ).attr( 'data-query-args' ),
				},
				success: function( result ) {
					// Add them to the pagination.
					$( '#pagination' ).attr( 'data-query-args', result );

					// Reset the posts.
					$cdbootstrapWin.trigger( 'reset-posts' );

					// Update active class.
					$( '.post-type-filter-link' ).removeClass( 'pre-active' );
					$link.toggleClass( 'active' );
					cdboostrapCountAppliedFilters();

				},

				error: function( jqXHR, exception ) {
					cdbootstrapAjaxErrors( jqXHR, exception );
				}
			} );

			return false;

		} );

		//author filter links
		$cdbootstrapDoc.on( 'click', '.author-filter-link', function() {

			$( 'body' ).addClass( 'filtering-posts' );

			var $link 		= $( this ),
				author 	= $link.data( 'filter-author-id' ) ? $link.data( 'filter-author-id' ) : '',
				addAuthor	= $( this ).hasClass( 'active' ) ? false : true; //Should we add or remove the post type from the query.

			$link.addClass( 'pre-active' );

			$.ajax({
				url: majesco_2022_ajax_filters.ajaxurl,
				type: 'post',
				data: {
					action: 	'majesco_2022_ajax_filters_author',
					author: 	author,
					addAuthor:	addAuthor,
					query:		$( '#pagination' ).attr( 'data-query-args' ),
				},
				success: function( result ) {

					// Add them to the pagination.
					$( '#pagination' ).attr( 'data-query-args', result );

					// Reset the posts.
					$cdbootstrapWin.trigger( 'reset-posts' );

					// Update active class.
					$( '.author-filter-link' ).removeClass( 'pre-active' );
					$link.toggleClass( 'active' );
					cdboostrapCountAppliedFilters();

				},

				error: function( jqXHR, exception ) {
					cdbootstrapAjaxErrors( jqXHR, exception );
				}
			} );

			return false;

		} );

		$cdbootstrapDoc.on( 'click', '#filter-pane-clear', function() {

			var blockFilter = $(this).data( 'block-filter' ) ? $(this).data( 'block-filter' ) : '';

			$( 'body' ).addClass( 'filtering-posts' );

			$.ajax({
				url: majesco_2022_ajax_filters.ajaxurl,
				type: 'post',
				data: {
					action: 	'majesco_2022_ajax_filters_clear',
					query:		$( '#pagination' ).attr( 'data-query-args' ),
					blockFilter: blockFilter,
				},
				success: function( result ) {

					// Add them to the pagination.
					$( '#pagination' ).attr( 'data-query-args', result );

					// Reset the posts.
					$cdbootstrapWin.trigger( 'reset-posts' );

					// Update active class.
					$( '.filter-link, .post-type-filter-link, .author-filter-link' ).removeClass( 'pre-active active' );
					cdboostrapCountAppliedFilters();
					var params = new window.URLSearchParams(window.location.search);
					params.forEach( (value, key) => {
						params.delete(value);
					});

				},

				error: function( jqXHR, exception ) {
					cdbootstrapAjaxErrors( jqXHR, exception );
				}
			} );

			return false;

		} );

	}

} // cdbootstrap.filters

/*	-----------------------------------------------------------------------------------------------
	Search
--------------------------------------------------------------------------------------------------- */

cdbootstrap.search = {

	init: function() {
		//Resource Hub Search
		$cdbootstrapDoc.on( 'submit', '#resource-hub-searchform', function(e) {

			e.preventDefault();

			$( 'body' ).addClass( 'filtering-posts' );

			var $form 		= $( this ),
				$search		= $form.serializeArray()[0].value;

			$form.addClass( 'pre-active' );

			$.ajax({
				url: majesco_2022_ajax_filters.ajaxurl,
				type: 'post',
				data: {
					action: 	'majesco_2022_ajax_search',
					search:		$search,
					query:		$( '#pagination' ).attr( 'data-query-args' ),
				},
				success: function( result ) {

					// Add them to the pagination.
					$( '#pagination' ).attr( 'data-query-args', result );

					// Reset the posts.
					$cdbootstrapWin.trigger( 'reset-posts' );

					// Update active class.
					$( '#resource-hub-searchform' ).removeClass( 'pre-active' );

				},

				error: function( jqXHR, exception ) {
					cdbootstrapAjaxErrors( jqXHR, exception );
				}
			} );

			return false;

		} );

	}

} // cdbootstrap.search

/*	-----------------------------------------------------------------------------------------------
	Ajax paginate links
--------------------------------------------------------------------------------------------------- */

cdbootstrap.paginateLinks = {

	init: function() {
		//Resource Hub Search
		$cdbootstrapDoc.on( 'click', '.ajax-pagination a.page-link', function(e) {

			e.preventDefault();

			$( 'body' ).addClass( 'filtering-posts' );

			var $pageLink 		= $( this ),
				url 			= new URL( $pageLink[0].href ),
				path			= url.pathname.split('/'),
				index			= path.indexOf('page'),
				page			= 1;

			if( index ){
				page = path[ index + 1 ]
			}

			$.ajax({
				url: majesco_2022_ajax_filters.ajaxurl,
				type: 'post',
				data: {
					action: 	'majesco_2022_ajax_page_link',
					page:		page,
					query:		$( '#pagination' ).attr( 'data-query-args' ),
				},
				success: function( result ) {

					// Add them to the pagination.
					$( '#pagination' ).attr( 'data-query-args', result );
					// Reset the posts.
					$cdbootstrapWin.trigger( 'reset-posts' );

				},

				error: function( jqXHR, exception ) {
					cdbootstrapAjaxErrors( jqXHR, exception );
				}
			} );

			return false;

		} );

	}

} // cdbootstrap.paginateLinks

/*	-----------------------------------------------------------------------------------------------
	Element In View
--------------------------------------------------------------------------------------------------- */

cdbootstrap.elementInView = {

	init: function() {

		var $targets = $( 'body.has-anim .do-spot' );
		cdbootstrap.elementInView.run( $targets );

		// Rerun on AJAX content loaded.
		$cdbootstrapWin.on( 'ajax-content-loaded', function() {
			$targets = $( 'body.has-anim .do-spot' );
			cdbootstrap.elementInView.run( $targets );
		} );

	},

	run: function( $targets ) {

		if ( $targets.length ) {

			// Add class indicating the elements will be spotted.
			$targets.each( function() {
				$( this ).addClass( 'will-be-spotted' );
			} );

			cdbootstrap.elementInView.handleFocus( $targets );

			$cdbootstrapWin.on( 'load resize orientationchange did-interval-scroll', function() {
				cdbootstrap.elementInView.handleFocus( $targets );
			} );

		}

	},

	handleFocus: function( $targets ) {

		// Check for our targets.
		$targets.each( function() {

			var $this = $( this );
			var checkAbove;

			if ( cdbootstrap.elementInView.isVisible( $this, checkAbove = true ) ) {
				$this.addClass( 'spotted' ).trigger( 'spotted' );
			}

		} );

	},

	// Determine whether the element is in view.
	isVisible: function( $elem, checkAbove ) {

		if ( typeof checkAbove === 'undefined' ) {
			checkAbove = false;
		}

		var winHeight 				= $cdbootstrapWin.height();

		var docViewTop 				= $cdbootstrapWin.scrollTop(),
			docViewBottom			= docViewTop + winHeight,
			docViewLimit 			= docViewBottom;

		var elemTop 				= $elem.offset().top;

		// If checkAbove is set to true, which is default, return true if the browser has already scrolled past the element.
		if ( checkAbove && ( elemTop <= docViewBottom ) ) {
			return true;
		}

		// If not, check whether the scroll limit exceeds the element top.
		return ( docViewLimit >= elemTop );

	}

} // cdbootstrap.elementInView

/*	-----------------------------------------------------------------------------------------------
	Masonry
--------------------------------------------------------------------------------------------------- */

cdbootstrap.masonry = {

	init: function() {

		var $wrapper = $( '.posts-grid' );

		if ( $wrapper.length ) {

			$wrapper.imagesLoaded( function() {

				var $grid = $wrapper.masonry( {
					columnWidth: 		'.grid-sizer',
					itemSelector: 		'.article-wrapper',
					percentPosition: 	true,
					stagger:			0,
					transitionDuration: 0,
				} );

				// Trigger will-be-spotted elements.
				$grid.on( 'layoutComplete', function() {
					$cdbootstrapWin.trigger( 'scroll' );
				} );

				// Check for Masonry layout changes on an interval. Accounts for DOM changes caused by lazyloading plugins.
				// The interval is cleared when all previews have been spotted.
				cdbootstrap.masonry.intervalUpdate( $grid );

				// Reinstate the interval when new content is loaded.
				$cdbootstrapWin.on( 'ajax-content-loaded', function() {
					cdbootstrap.masonry.intervalUpdate( $grid );
				} );

			} );

		}

	},

	intervalUpdate: function( $grid ) {

		var masonryLayoutInterval = setInterval( function() {

			$grid.masonry();

			// Clear the interval when all previews have been spotted.
			if ( ! $( '.preview.do-spot:not(.spotted)' ).length ) clearInterval( masonryLayoutInterval );

		}, 1000 );

	}

} // cdbootstrap.masonry


/*	-----------------------------------------------------------------------------------------------
	Function Calls
--------------------------------------------------------------------------------------------------- */

$cdbootstrapDoc.ready( function() {

	//cdbootstrap.intervalScroll.init();			// Check for scroll on an interval.
	cdbootstrap.toggles.init();					// Handle toggles.
	//cdbootstrap.coverModals.init();				// Handle cover modals.
	//cdbootstrap.elementInView.init();			// Check if elements are in view.
	//cdbootstrap.instrinsicRatioVideos.init();	// Retain aspect ratio of videos on window resize.
	//cdbootstrap.stickyHeader.init();				// Stick the header.
	//cdbootstrap.scrollLock.init();				// Scroll Lock.
	//cdbootstrap.mainMenu.init();					// Main Menu.
	//cdbootstrap.focusManagement.init();			// Focus Management.
	cdbootstrap.loadMore.init();					// Load More.
	cdbootstrap.filters.init();						// Filters.
	cdbootstrap.search.init();						// Search.
	cdbootstrap.paginateLinks.init();				// Pagination links after searching, filtering, etc
	//cdbootstrap.masonry.init();					// Masonry.
	//cdbootstrap.dynamicHeights.init();			// Dynamic Heights.

	// Call css-vars-ponyfill.
	//cssVars();

} );
